/** PRD v0.1 Section 6 / LNG-01 — supported transcription languages */
export const DEFAULT_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'tw', label: 'Twi' },
  { code: 'ee', label: 'Ewe' },
  { code: 'ha', label: 'Hausa' },
  { code: 'ga', label: 'Ga' },
  { code: 'fr', label: 'French' },
  { code: 'zh', label: 'Chinese' },
  // { code: 'dag', label: 'Dagbani' },
  // { code: 'fat', label: 'Fante' },
];

export const normalizeLanguageOptions = (payload) => {
  if (!payload) return DEFAULT_LANGUAGES;

  const list = Array.isArray(payload) ? payload : payload.data || payload.languages;
  if (!Array.isArray(list) || list.length === 0) return DEFAULT_LANGUAGES;

  const allowed = new Set(DEFAULT_LANGUAGES.map((lang) => lang.label.toLowerCase()));
  const mapped = list
    .map((item) => {
      if (typeof item === 'string') {
        return { code: item.toLowerCase().slice(0, 2), label: item };
      }
      return {
        code: item.code || item.id || item.label,
        label: item.label || item.name || item.code,
      };
    })
    .filter((item) => allowed.has(String(item.label || '').toLowerCase()));

  // Prefer the API list as-is when it is the platform-enabled catalog.
  return mapped.length ? mapped : DEFAULT_LANGUAGES;
};
